import { render, staticRenderFns } from "./BdbTicket.vue?vue&type=template&id=3659847c"
import script from "./BdbTicket.vue?vue&type=script&lang=js"
export * from "./BdbTicket.vue?vue&type=script&lang=js"
import style0 from "./BdbTicket.vue?vue&type=style&index=0&id=3659847c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports